<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true">
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs8>
              <div class="x-text-field">
                <label>汇款单位</label>
                <div>{{item.drawee}}</div>
              </div>
            </v-flex>

            <v-flex xs4>
              <div class="x-text-field">
                <label>到款日期</label>
                <div>{{item.paymentDate}}</div>
              </div>
            </v-flex>

            <v-flex xs6>
              <div class="x-text-field">
                <label>到款金额</label>
                <div>{{item.amount}}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>到款次数</label>
                <div>{{item.serialNum}}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>到款性质</label>
                <div>{{item.property}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>到款拆分</label>
                <div>{{item.partition.name}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <v-data-table
                class="dense"
                :headers="headers"
                :items="item.fundItems"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.index + 1}}</td>
                  <td><span :style="`padding-left: ${props.item.level-1}em`">{{props.item.partitionName}}</span></td>
                  <td>{{ Math.round(props.item.percent * 100) / 100 }}%</td>
                  <td>
                    {{(props.item.amount || 0) | currency }}
                  </td>
                  <td>{{props.item.cardName}}<br/>{{props.item.cardNumber}}</td>
                </template>
              </v-data-table>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseURI = '/api/proj/fund/income';

  export default {
    mixins: [mixin.view(baseURI)],

    data() {
      return {
        item: {
          "partition": {}
        },

        headers: [
          {text: '#', sortable: false, value: 'rank', width: 18},
          {text: '拆分项目名称', sortable: false, value: 'name'},
          {text: '经费百分比', sortable: false, value: 'percent'},
          {text: '金额（元）', sortable: false, value: 'note', width: 150},
          {text: '经费卡', sortable: false, value: 'note', width: 250},
        ],
      }
    }
  }
</script>
